import { Sport } from '@sorare/core/src/__generated__/globalTypes';

import { ClubEditorPage } from 'pages/profile/ClubEditor';

const EditPage = () => <ClubEditorPage sport={Sport.FOOTBALL} />;

export default EditPage;
